import { Inject, Injectable, NgZone, DOCUMENT } from '@angular/core';
import { ViewportRuler as CdkViewportRuler  } from '@angular/cdk/scrolling';

import { Platform } from '@angular/cdk/platform';

@Injectable({ providedIn: 'root' })
export class ViewportRuler extends CdkViewportRuler {

  constructor(@Inject(Platform) platform: Platform, @Inject(NgZone) ngZone: NgZone, @Inject(DOCUMENT) document: Document) {
    super(platform, ngZone, document);
  }
}
